'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  STAMP_SHARE: null,
  STAMP_MORE: null,
  ZINE_SHARE: null,
  ZINE_MORE: null,
  USER_PROFILE: null,
  USER_SHARE: null,
  CREATE: null,
  ZINE_COLOR_PICKER: null,
  STAMP_STATUS_PICKER: null,
  ZINE_STATUS_PICKER: null,
  EDITOR_MORE: null
});


/** WEBPACK FOOTER **
 ** ./constants/ContextMenuTypes.js
 **/